import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage'; // 添加 Storage 导入
import { setLogLevel } from 'firebase/firestore';
setLogLevel('debug');

const firebaseConfig = {
  apiKey: "AIzaSyDvHQ3mg3y4sHiRozE0r4xs1ZmPflT4A_4",
  authDomain: "xiaocixia-e7a94.firebaseapp.com",
  projectId: "xiaocixia-e7a94",
  storageBucket: "xiaocixia-e7a94.firebasestorage.app",
  messagingSenderId: "967114062746",
  appId: "1:967114062746:web:7d5be061ceaeb9e4d8d823",
  measurementId: "G-MEASUREMENT_ID"
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app); // 初始化 Storage


export { auth, db, storage }; // 导出 storage